import { push } from "connected-react-router";
import { CustomColumnType } from "./grid-column-types";
import { broadcastAppInsightsNavigationEvent, createLink } from "./renderers/datapointLinkCellRenderer";
import { language } from "language/default";
import { setDashboardOptions } from "store/current-dashboard";
const filterMenuItems = (items) => items.filter((item) => item !== "rowGroup");
const filterFinalMenuItems = (items) => items.filter((item) => item !== "export" && item !== "separator");
const isDatapointLinkColumn = (params) => params.column?.getColDef()?.type?.includes(CustomColumnType.InsDatapointLinkColumn) ?? false;
const getLinkMappingForColumn = (params) => {
    const field = params.column?.getColDef()?.field;
    return params.context?.linksMapping?.find((m) => m.field === field);
};
const createOpenLinkMenuItem = (link, options, mapping, currentDashboardType, dispatch) => ({
    action: () => {
        broadcastAppInsightsNavigationEvent(mapping.path, currentDashboardType);
        dispatch(push(link));
        if (options) {
            dispatch(setDashboardOptions(options));
        }
    },
    name: language.en.grid.openLink
});
const createOpenLinkInNewTabMenuItem = (link, mapping, currentDashboardType) => ({
    action: () => {
        broadcastAppInsightsNavigationEvent(mapping.path, currentDashboardType);
        window.open(link, "_blank");
    },
    name: language.en.grid.openLinkNewTab
});
const buildLinkMenuItems = (params, currentDashboardType, dispatch) => {
    const mapping = getLinkMappingForColumn(params);
    if (!mapping) {
        return null;
    }
    const { link, options } = createLink(mapping, params.node?.data);
    if (!link) {
        return null;
    }
    return [
        createOpenLinkMenuItem(link, options, mapping, currentDashboardType, dispatch),
        createOpenLinkInNewTabMenuItem(link, mapping, currentDashboardType)
    ];
};
const addCustomMenuItems = (items, getContextMenuItems, params) => {
    if (!getContextMenuItems) {
        return;
    }
    const customItems = getContextMenuItems(params);
    customItems.forEach((item) => items.push(item));
};
export const buildCustomContextMenu = (getContextMenuItems, currentDashboardType, dispatch) => (params) => {
    const defaultItems = params.defaultItems ?? [];
    const newItems = filterMenuItems(defaultItems);
    addCustomMenuItems(newItems, getContextMenuItems, params);
    if (isDatapointLinkColumn(params)) {
        const linkMenuItems = buildLinkMenuItems(params, currentDashboardType, dispatch);
        if (linkMenuItems) {
            return [
                ...linkMenuItems,
                "separator",
                ...filterFinalMenuItems(newItems)
            ];
        }
    }
    return filterFinalMenuItems(newItems);
};
export const setMainMenuItems = (params, gridParam) => {
    const defaultItems = params.defaultItems ?? [];
    const newItems = defaultItems.filter((e) => e !== "rowGroup");
    if (gridParam) {
        const showFilterRow = gridParam.auxGridConfiguration.auxMenuItems.getAuxMenuItem("showFilterRow", params);
        const fontSize = gridParam.auxGridConfiguration.auxMenuItems.getAuxMenuItem("fontSize", params);
        const paddingSize = gridParam.auxGridConfiguration.auxMenuItems.getAuxMenuItem("paddingSize", params);
        newItems.unshift(paddingSize);
        newItems.unshift(fontSize);
        newItems.unshift("separator");
        newItems.unshift(showFilterRow);
        newItems.unshift("separator");
    }
    return newItems;
};
